// Traduction de l'interface en anglais, sans réécrire chaque écran : les textes affichés sont
// remplacés à la volée d'après le dictionnaire (i18n/en.js), y compris ceux qui apparaissent
// ensuite. Les contenus pédagogiques et les messages ne sont jamais touchés : formules, éditeurs,
// champs de saisie et zones marquées translate="no".
import EN, { MOTIFS_EN } from "../i18n/en";

const ATTRIBUTS = ["placeholder", "title", "aria-label", "alt"];
const EXCLUS = "script,style,textarea,code,pre,math-field,[contenteditable=''],[contenteditable='true'],[translate='no'],.notranslate,.katex,.ML__container,mjx-container";
const traduits = new WeakMap();  // nœud texte → dernier texte écrit par la traduction
let observateur = null;

export function traduireTexte(texte, dico = EN, motifs = MOTIFS_EN) {
  if (!texte) return texte;
  const m = texte.match(/^(\s*)([\s\S]*?)(\s*)$/);
  const coeur = m[2].replace(/\s+/g, " ");
  if (!coeur || !/[A-Za-zÀ-ÿ]/.test(coeur)) return texte;
  if (Object.prototype.hasOwnProperty.call(dico, coeur)) return m[1] + dico[coeur] + m[3];
  for (const [motif, remplacement] of motifs) {
    if (motif.test(coeur)) return m[1] + coeur.replace(motif, remplacement) + m[3];
  }
  return texte;
}

function exclu(element) {
  return !element || !!element.closest?.(EXCLUS);
}

function traduireNoeudTexte(noeud) {
  if (traduits.get(noeud) === noeud.nodeValue) return;
  if (exclu(noeud.parentElement)) return;
  const avant = noeud.nodeValue;
  const apres = traduireTexte(avant);
  if (apres !== avant) noeud.nodeValue = apres;
  traduits.set(noeud, noeud.nodeValue);
}

function traduireAttributs(element) {
  if (exclu(element) && !(element.matches?.("textarea,input") && !element.closest("[translate='no']"))) return;
  for (const nom of ATTRIBUTS) {
    const valeur = element.getAttribute?.(nom);
    if (valeur) {
      const apres = traduireTexte(valeur);
      if (apres !== valeur) element.setAttribute(nom, apres);
    }
  }
  if (element.matches?.("input[type=button],input[type=submit]") && element.value) {
    const apres = traduireTexte(element.value);
    if (apres !== element.value) element.value = apres;
  }
}

export function traduireArbre(racine) {
  if (!racine) return;
  if (racine.nodeType === Node.TEXT_NODE) { traduireNoeudTexte(racine); return; }
  if (racine.nodeType !== Node.ELEMENT_NODE && racine.nodeType !== Node.DOCUMENT_NODE) return;
  if (racine.nodeType === Node.ELEMENT_NODE) {
    if (exclu(racine) && !racine.matches("textarea,input")) return;
    traduireAttributs(racine);
  }
  const marche = document.createTreeWalker(racine, NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_TEXT);
  for (let n = marche.nextNode(); n; n = marche.nextNode()) {
    if (n.nodeType === Node.TEXT_NODE) traduireNoeudTexte(n);
    else traduireAttributs(n);
  }
}

export function installerTraduction(racine = document.body) {
  if (observateur || !racine) return;
  document.documentElement.lang = "en";
  traduireArbre(racine);
  if (document.title) document.title = traduireTexte(document.title);
  observateur = new MutationObserver((mutations) => {
    for (const mut of mutations) {
      if (mut.type === "characterData") traduireNoeudTexte(mut.target);
      else if (mut.type === "attributes") traduireAttributs(mut.target);
      else mut.addedNodes.forEach(traduireArbre);
    }
  });
  observateur.observe(racine, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ATTRIBUTS });
}

export function arreterTraduction() {
  observateur?.disconnect();
  observateur = null;
}
